<script lang="ts">
    import { apiBaseURL } from "../config"
    import { i18n } from "../store"
    import ResponsiveImages from "./ResponsiveImages.svelte"

    export let news: Seite
</script>

<div class="post">
    <div class="item">
        <div class="image">
            <ResponsiveImages
                desktop="{apiBaseURL +
                    '/seiten/' +
                    news.id +
                    '/' +
                    news.bild2?.src}"
                mobile="{apiBaseURL +
                    '/seiten/' +
                    news.id +
                    '/' +
                    news.bild3?.src}"
                alt="{news.titel}"
            />
        </div>
        <div class="text">
            <div class="inner">
                <h3>
                    {#if news.pdfdownload}
                        <!-- svelte-ignore security-anchor-rel-noreferrer -->
                        <a
                            target="_blank"
                            href="{apiBaseURL +
                                '/seiten/' +
                                news.id +
                                '/' +
                                news.pdfdownload?.src}">{@html news.titel}</a
                        >
                    {:else if news.link}
                        <!-- svelte-ignore security-anchor-rel-noreferrer -->
                        <a target="_blank" href="{news.link}"
                            >{@html news.titel}</a
                        >
                    {:else}
                        <a href="/{news.pfad}">{@html news.titel}</a>
                    {/if}
                </h3>
                <div class="date">
                    {@html news.subtitle ? news.subtitle : ""}
                </div>
                <p>
                    {#if news.teaserText}
                        {@html news.teaserText}
                    {/if}
                </p>
            </div>
            {#if news.pdfdownload}
                <!-- svelte-ignore security-anchor-rel-noreferrer -->
                <a
                    target="_blank"
                    href="{apiBaseURL +
                        '/seiten/' +
                        news.id +
                        '/' +
                        news.pdfdownload?.src}"
                    class="btn">{$i18n("mehr")}</a
                >
            {:else if news.link}
                <!-- svelte-ignore security-anchor-rel-noreferrer -->
                <a target="_blank" href="{news.link}" class="btn"
                    >{$i18n("mehr")}</a
                >
            {:else}
                <a href="/{news.pfad}" class="btn">{$i18n("mehr")}</a>
            {/if}
        </div>
    </div>
</div>

<style lang="less">
    @import "../css/base.less";

    // List
    .post {
        width: 50%;
        @media (max-width: 950px) {
            width: 100%;
        }
        @media (max-width: 530px) {
            display: block;
        }
    }
    .item {
        background: #fff;
        -webkit-box-shadow: 0px 0px 20px 3px rgba(0, 0, 0, 0.1);
        box-shadow: 0px 0px 20px 3px rgba(0, 0, 0, 0.1);
        .transition();
        .flex();
        @media (max-width: 530px) {
            flex-direction: column;
        }
        .image :global {
            width: 30%;
            height: 100%;
            flex-shrink: 0;
            @media (max-width: 530px) {
                width: 100%;
                height: 50vw;
            }
            img {
                height: 100%;
                width: 100%;
                object-fit: cover;
            }
        }
        .text {
            padding: 20px;
            .flex();
            flex-direction: column;
            justify-content: space-between;
            align-items: flex-start;
            h3 {
                font-size: 1.2rem;
                margin: 0px 0px 0px 0px;
                color: @textcolor;
                a {
                    color: @textcolor;
                    .transition();
                }
            }
            .date {
                font-size: 0.9rem;
                margin-bottom: 20px;
            }
        }
        &:hover {
            -webkit-box-shadow: 0px 0px 23px 5px rgba(0, 0, 0, 0.2);
            box-shadow: 0px 0px 23px 5px rgba(0, 0, 0, 0.2);
            .text h3 > a {
                color: @maincolor;
            }
        }
    }
</style>
